// extracted by mini-css-extract-plugin
export var box = "_4e-0";
export var check = "_4e-1";
export var checkboxButton = "_4e-6";
export var checkboxGroup = "_4e-5";
export var disabled = "_4e-7";
export var ghost = "_4e-9";
export var input = "_4e-2";
export var label = "_4e-4";
export var normal = "_4e-8";
export var uncheck = "_4e-3";